import cx from 'classnames'
import React from 'react'

import { Modal } from '../Modal'
import { selectUrls, selectCurrency } from '../../stores/selectors'
import { generateUrl } from '../../utils/url'

export type Props = {
  onClose: () => void
  isOpen: boolean
}

export const LanguageSettingsModal = ({ isOpen, onClose }: Props) => {
  const urls = selectUrls()
  const currency = selectCurrency()
  return (
    <Modal
      id='wl-spainholiday-header-lang-settings-modal'
      closeButtonId='wl-spainholiday-header-lang-settings-modal-close'
      title='Languages'
      onClose={onClose}
      className={cx('z-mobile-language-settings', { hidden: !isOpen })}
      contentClassName='w-full sm:max-w-language-settings-mobile'
    >
      <div className='py-3'>
        <ul className='site-settings-list capitalize'>
          {urls.map(
            ({ siteId, href, languageCode, languageName, isCurrentSite }) => (
              <li key={siteId}>
                <a
                  href={generateUrl(href, currency)}
                  hrefLang={languageCode}
                  className={`inline-block pl-2 mb-3 text-sm ${
                    isCurrentSite ? 'font-semibold' : 'font-normal'
                  }`}
                >
                  <img
                    alt=''
                    className='mr-2'
                    src={`${process.env.PUBLIC_PATH}assets/images/flags/${languageCode}.jpg`}
                  />
                  {languageName}
                </a>
              </li>
            ),
          )}
        </ul>
      </div>
    </Modal>
  )
}
